import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import copies from '../../copies.json';

export const DragAndDrop = ({ children, onDrop, types, takeFirst, className, ...props }) => {
    const [isDragOverStarted, toggleDragOver] = useState(false);
    const [counter, setCount] = useState(0);

    const ACCEPT_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];

    const onDragEnter = e => {
        let count = counter + 1;
        e.preventDefault();
        e.stopPropagation();
        toggleDragOver(count > 0);
        setCount(count);
    };
    const onDragLeave = e => {
        let count = counter - 1;
        toggleDragOver(count > 0);
        setCount(count);
    };
    const onFileDrop = e => {
        e.preventDefault();
        setCount(0);
        toggleDragOver(false);
        onDrop(e.dataTransfer.files);
    };
    const onDragOver = e => {
        e.preventDefault();
        e.stopPropagation();
    };
    return (
        <div
            className={classNames(styles.dropWrapper, className)}
            onDrop={onFileDrop}
            onDragOver={onDragOver}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            {...props}
        >
            {isDragOverStarted && (
                <div className={styles.dropContaner}>
                    <div className={styles.block}>
                        <img src='/assets/img/burst.png' alt='' />
                        <p className={styles.text}>{copies.drag_and_drop}</p>
                    </div>
                </div>
            )}
            {children}
        </div>
    );
};

export default DragAndDrop;
